<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
export default {
  name: 'App',
  data() {
    return {
      isRouterAlive: true
    }
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  created() {
    this.initMessage()
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    initMessage() {
      let host = location.host
      if (host === 'wk.hyunst.com') {
        this.setSystemInfo('号云世纪', './hy-logo.png')
      } else if (host === 'wk.zwot.cn') {
        this.setSystemInfo('创享微联', './cx-favicon.ico')
      } else if (host === 'sh.zwot.cn') {
        this.setSystemInfo('推推店', './xqjx-favicon.ico')
      } else if (host === 'syxf.hyunst.com') {
        this.setSystemInfo('三亚消防', './syxf-logo.png')
      } else if (host === 'bkx.hyunst.com') {
        this.setSystemInfo('爆客侠', './bkx-favicon.ico')
      } else if (host === 'univs.hyunst.com') {
        this.setSystemInfo('树懒高校', './gx-favicon.png')
      } else {
        this.setSystemInfo('号云世纪', './hy-logo.png')
      }
    },
    // hyunSystemInfo() {
    //   this.systemName = '号云世纪'
    //   this.setFavicon('./hy-logo.png')
    //   document.title = this.systemName
    // },
    // cxSystemInfo() {
    //   this.systemName = '创享微联'
    //   this.setFavicon('./cx-favicon.ico')
    //   document.title = this.systemName
    // },
    setSystemInfo(systemName, iconUrl) {
      this.systemName = systemName
      this.setFavicon(iconUrl)
      document.title = this.systemName
    },

    // 设置系统导航icon
    setFavicon(path) {
      if (!path || path.length === 0) {
        throw new Error('argument "path" is required !')
      }
      var head = document.getElementsByTagName('head')[0]
      var link = document.createElement('link')
      link.href = path
      link.rel = 'icon'
      link.type = 'image/x-iconxsss'
      head.appendChild(link)
    }
  }
}
</script>
<style>
@import 'assets/iconfont/iconfont.css';
/* @import 'assets/iconfont1/iconfont.css'; */
</style>
